export const wrapInQuotes = (text, wrapper = '\"') => {
  return `${wrapper}${text}${wrapper}`
}

export enum SellingChannel {
  D2C = 'D2C',
  MERCHBAR = 'MERCHBAR',
  WHOLESALE = 'WHOLESALE'
}

export const MERCHANT_FEE_AMOUNT = 0.029;

export const displayOrderSort = (a, b) => a.display_order - b.display_order;
export const onlyUnique = (value, index, self) => self.indexOf(value) === index;

export const DEFAULT_TAKE: number = 10;
export const MAX_TAKE: number = 50;

export const EXPIRES_IN: number = 604800;

export const AWS_PUBLIC_BUCKET: string = 'dispatch-public';
export const AWS_MEDIA_BUCKET: string = 'dispatch-private-media';

export const WHOLESALE_PREORDER_OFFSET = 16;
export const EMPTY_CONTENT_IMAGE = 'https://polyvinyl-public.s3.amazonaws.com/ddfd73da687b249d8b59329addb805aeb5be63fa_3252c92422e22823e60bd75be395a5003c53478c_thumb_png'

export const DEFAULT_ITEMS_PER_PAGE: number = 8;
export const VARIOUS_ARTISTS: string = 'Various Artists'
export const SHIPSTATION_EXPORT_PER_PAGE = 800;
export const PRODUCTS_PER_PDF_PAGE: number = 18;
export const TRACK_TYPES = ['MUSIC', 'VIDEO']
export const SHOW_RELEASE = ['MUSIC']
export const GIFT_CARD_TYPE = 'GIFTCARD'
export const GIFT_CARD_TYPE_IDS = [169, 170, 171]
export const GIFT_CARD_INSTANCE_IDS = [867, 3434, 4932, 5246, 5924, 2283, 3911, 4493, 5299, 5615]
export const CLOTHING_PARENT_TYPE_IDS = [3, 52, 53, 86, 98, 102, 108, 117, 215, 250, 276]
export const POLYVINYL_RECORD_LABEL_IDS = [248, 64, 308]

export const PRODUCT_DETAIL_MODULES = {
  HEADER: 'HEADER',
  INSTANCES: 'INSTANCES',
  RECORD_LABEL: 'RECORD_LABEL',
  SPOTIFY_EMBED: 'SPOTIFY_EMBED',
  YOUTUBE_EMBED: 'YOUTUBE_EMBED',
  EXTRA_DATA: 'EXTRA_DATA',
  BUNDLES: 'BUNDLES',
  VIDEOS: 'VIDEOS',
  DESCRIPTION: 'DESCRIPTION',
  TRACKLIST: 'TRACKLIST',
  REVIEWS: 'REVIEWS',
  RELATED_PRODUCTS: 'RELATED_PRODUCTS',
  RELATED_ARTISTS: 'RELATED_ARTISTS',
  TOUR: 'TOUR',
}

export const FOOTER_MODULES = {
  LINKS: 'links',
  EMAIL: 'email',
  SOCIALS: 'socials',
}

export const TOOLBAR_MODULES = {
  STORE: 'store',
  LINK: 'link',
  ARTIST: 'artist',
  NEWS: 'news',
  TOURS: 'tours',
  DISCOGRAPHY: 'discography',
  ABOUT: 'about'
}

export const ECOMMERCE_CODE = {
  credit: 'CREDIT',
  paypal: 'PAYPAL'
}

export const FRIENDLY_ECOMMERCE_CODE = {
  'CREDIT': 'Credit',
  'PAYFLOWDIRECT': 'Credit Card',
  'PAYPAL': 'Paypal'
}

export const BRAINTREE_PAYMENT_INSTRUMENT_TYPE = {
  CREDIT_CARD: 'credit_card',
  GIFT_CARD: 'credit',
  VENMO: 'venmo_account',
  PAYPAL: 'paypal_account',
  APPLE_PAY: 'apple_pay_card',
}

export const FRIENDLY_PAYER_STATUS = {
  'credit': 'Credit',
  'venmo_account': 'Venmo',
  'credit_card': 'Credit Card',
  'paypal_account': 'Paypal',
  'apple_pay_card': 'Apple Pay'
}

export const TYPE_CD = {
  INITIAL: 'INITIAL',
  ADJUSTMENT: 'ADJUSTMENT'
}

export const SLACK_SLACKBOT = "https://hooks.slack.com/services/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";
export const SLACK_ERRORS_CMS_PVFD = "https://hooks.slack.com/services/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";
export const SLACK_FUGA_PVFD = "https://hooks.slack.com/services/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";
export const SLACK_FUGA_ALERTS = "C0BV9PVV5KK";
export const SLACK_MARKETING_PVFD = "https://hooks.slack.com/services/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";
export const SLACK_DROPBOX_PVFD = "https://hooks.slack.com/services/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"
export const SLACK_DEV_DEPLOY_PVFD = "https://hooks.slack.com/services/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";
export const SLACK_UPDATE_CACHE = "https://hooks.slack.com/services/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";
export const SLACK_ERRORS_PAYMENT = "https://hooks.slack.com/services/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";
export const SLACK_SHIPMENTS = "https://hooks.slack.com/services/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";
export const SLACK_MAILCHIMP = "https://hooks.slack.com/services/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";
export const SLACK_MERCHBAR = "https://hooks.slack.com/services/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";
export const SLACK_ORDERS = "https://hooks.slack.com/services/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";
export const SLACK_WHOLESALE = "https://hooks.slack.com/services/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";
export const SLACK_NOTIFICATIONS = "https://hooks.slack.com/services/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";
export const SLACK_MAILORDER = "https://hooks.slack.com/services/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";
export const SLACK_LOYALTY = "https://hooks.slack.com/services/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";
export const SLACK_PV_WHOLESALE = "https://hooks.slack.com/services/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";
export const SLACK_CMS_AUDIT_LOG = "https://hooks.slack.com/services/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";
export const SLACK_GOOGLE_ANALYTICS = "https://hooks.slack.com/services/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";
export const SLACK_SHOPIFY = "https://hooks.slack.com/services/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";
export const SLACK_META = "https://hooks.slack.com/services/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";
export const SLACK_SHOPIFY_PLUS = "https://hooks.slack.com/services/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";
//

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// ~~~~~~~~~~~ SENDGRID ~~~~~~~~~~~~~
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
export const SEND_EMAIL_DEV = `dev@polyvinylrecords.com`
export const SEND_EMAIL_NAME = `Dispatch Accounting`

export const SEND_MAIL_DEFAULT_CREATE_ACCOUNT_TEMPLATE_ID = 'd-3c5bfd913dd6460d98bd4cd28d95f1b8';
export const SEND_MAIL_WHOLESALE_DEFAULT_CREATE_ACCOUNT_TEMPLATE_ID = 'd-1fecd3780f7d4c14a9fdadbd2e830ea5';
export const SEND_MAIL_DEFAULT_RESET_PASSWORD_TEMPLATE_ID = 'd-e6b7da0b80b241fa87cb58854923cb90';

export const SEND_MAIL_DEFAULT_ORDER_CONFIRMATION_MAILORDER_TEMPLATE_ID = 'd-33dec81e69b24c76abe05aa2b743f14a'
export const SEND_MAIL_DEFAULT_ORDER_CONFIRMATION_WHOLESALE_TEMPLATE_ID = 'd-05ba4307323f439db19277d09a2c9546';

export const SEND_MAIL_DEFAULT_GIFT_CARD_TEMPLATE_ID = 'd-563d710d4c16488683652f9d7ac17d2d'
export const SEND_MAIL_DEFAULT_BACK_IN_STOCK_TEMPLATE_ID = 'd-a17274ee2155471f8b38ad5eff5883a4';

export const SEND_MAIL_DEFAULT_SCHEDULED_ORDER_REMINDER_TEMPLATE_ID = 'd-f5a1d2831f634cf38255f3519140a7c6'

// PV-ONLY
export const SEND_MAIL_FIRST_ORDER_COUPON_TEMPLATE_ID = 'd-c9be3d3761824b71a42f092c335a840b'
export const SEND_MAIL_PREORDER_DOWNLOAD_TEMPLATE_ID = 'd-d1275b80e11c4713a2e6ce8618e714c8'




export const routeStringToArray = (str: string) => str ? (str.split('/').filter(x => x).map((x, i) => i ? x : `/${x}`)) : []

export const DB_CONSTANTS = {
  various_artists: 'Various Artists',
  active: 'ACTIVE',
  archive: 'ARCHIVE',
  sale: 'sale',
  xofy: 'XOFY',
  free: 'FREE',
  pvFull: 'PVFULL',
  NONPV: 'NONPV',
  inactive: 'INACTIVE',
  notlisted: 'NOTLISTED',
  not_wholesale: 'NOTWHOLESALE',
  out: 'OUT',
  misc: [99, 100],
  exclude: 'EXCLUDE',
  include: 'INCLUDE'
}

export const CREDIT_CONDITION_TYPES = {
  account: 'ACCOUNT',
  date: 'DATE',
  instance: 'INSTANCE',
  quantity: 'QUANTITY',
  recent: 'RECENT'
}

export const PRODUCT_LIST_GROUP_SORTS = {
  release_desc: 'RELEASEDESC',
  artist: 'ARTIST',
  title: 'TITLE',
  format: 'FORMAT',
  release: 'RELEASE',
}

export const PRODUCT_LIST_GROUP_TYPE_CODE = {
  divider: 'DIVIDER',
  artist: 'ARTIST',
  typecd: 'TYPECD',
  reltype: 'RELTYPE',
  exclude: 'EXCLUDE',
  exclude_label: 'EXCLUDELABEL',
  exclude_product: 'EXCLUDEPRODUCT',
  record_label: 'RECORDLABEL',
  product: 'PRODUCT',
  package: 'PACKAGE',
  include_package: 'INCLUDEPACKAGE',
  includes: 'INCLUDE',
  selected: 'SELECTED'
}

export const PRODUCT_LIST_TYPE_CODE = {
  artist: 'artist',
  folder: 'folder',
  sale: 'sale',
  homepage: 'homepage',
  menu: 'menu',
  salefolder: 'salefolder'
}

export const DEFAULT_SHIPPING_RATES = [{
  label: 'USPS Media Mail Flat Rate',
  service_code: 'FLAT_RATE_5',
  delivery_time: 'On average, 3-14 days from ship date',
  flat_price: 5,
  status: DB_CONSTANTS.active,
  display_order: 1,
  is_mailorder: true,
  is_domestic: true,
  is_merchbar: true,
  is_wholesale: true,
  is_international: false,
}, {
  label: 'USPS Media Mail Free US Shipping ($50+)',
  service_code: 'FREE',
  delivery_time: 'On average, 3-14 days from ship date',
  flat_price: 0,
  status: DB_CONSTANTS.active,
  display_order: 1,
  min_cart: 50,
  is_mailorder: true,
  is_international: false,
  is_domestic: true,
}, {
  label: 'USPS First Class',
  service_code: 'usps_first_class_mail',
  carrier_code: 'stamps_com',
  delivery_time: 'On average, 2-5 days from ship date',
  status: DB_CONSTANTS.active,
  max_weight: 5,
  display_order: 3,
  is_mailorder: true,
  is_domestic: true,
  is_international: false,
}, {
  label: 'USPS Priority',
  service_code: 'usps_priority_mail',
  carrier_code: 'stamps_com',
  delivery_time: 'On average, 1-3 days from ship date',
  status: DB_CONSTANTS.active,
  display_order: 4,
  is_mailorder: true,
  is_domestic: true,
  is_international: false,
}, {
  label: 'FedEx Ground/Home Delivery',
  service_code: 'fedex_home_delivery',
  carrier_code: 'fedex',
  delivery_time: 'On average, 1-4 days from ship date',
  status: DB_CONSTANTS.active,
  display_order: 5,
  is_mailorder: true,
  is_domestic: true,
  is_international: false,
}, {
  label: 'FedEx Standard Overnight',
  service_code: 'fedex_standard_overnight',
  carrier_code: 'fedex',
  delivery_time: '1 Business Day',
  status: DB_CONSTANTS.active,
  display_order: 6,
  is_mailorder: true,
  is_domestic: true,
  is_international: false,
}, {
  label: 'USPS First Class International',
  service_code: 'usps_first_class_mail_international',
  carrier_code: 'stamps_com',
  delivery_time: 'On average, 1-3 weeks',
  max_weight: 64,
  status: DB_CONSTANTS.active,
  display_order: 7,
  is_mailorder: true,
  is_domestic: false,
  is_international: true,
}, {
  label: 'USPS Priority International',
  service_code: 'usps_priority_mail_international',
  carrier_code: 'stamps_com',
  delivery_time: 'On average, 1-2 Weeks',
  max_weight: 160,
  status: DB_CONSTANTS.inactive,
  display_order: 8,
  is_mailorder: true,
  is_domestic: false,
  is_international: true,
}, {
  label: 'FedEx International Economy',
  service_code: 'fedex_international_economy',
  carrier_code: 'fedex',
  delivery_time: 'On average, 2-5 Business Days',
  max_weight: 64,
  status: DB_CONSTANTS.active,
  display_order: 9,
  is_mailorder: true,
  is_domestic: false,
  is_international: true,
}, {
  label: 'FedEx International Priority',
  service_code: 'fedex_international_priority',
  carrier_code: 'fedex',
  delivery_time: 'On average, 1-3 Business Days',
  max_weight: 64,
  status: DB_CONSTANTS.active,
  display_order: 10,
  is_mailorder: true,
  is_domestic: false,
  is_international: true,
}]

export const DEFAULT_PERSON_ROLES = [
  { label: 'Musician', frontend_display: false, is_member: false, is_fintage: false },
  { label: 'Publicity', frontend_display: true, is_member: false, is_fintage: false },
  { label: 'Radio', frontend_display: true, is_member: false, is_fintage: false },
  { label: 'Label', frontend_display: true, is_member: false, is_fintage: false },
  { label: 'Management', frontend_display: true, is_member: false, is_fintage: false },
]

export const DEFAULT_PAGE_LAYOUTS = [
  { display_order: 1, page_type_cd: 'HOME', module_cd: "BANNER", json_config: `"{\"show_catalog_num\":2}"` },
  { display_order: 2, page_type_cd: 'HOME', module_cd: "PRODUCT_LIST", json_config: `"{\"low_quantity_number\":\"0\"}"` },
  { display_order: 3, page_type_cd: 'HOME', module_cd: "NEWS" },
  { display_order: 4, page_type_cd: 'HOME', module_cd: "VIDEOS" },

  { display_order: 1, page_type_cd: 'PRODUCT', module_cd: "HEADER", json_config: `"{\"show_catalog_num\":2}"` },
  { display_order: 2, page_type_cd: 'PRODUCT', module_cd: "INSTANCES", json_config: `"{\"low_quantity_number\":\"0\"}"` },
  { display_order: 3, page_type_cd: 'PRODUCT', module_cd: "BUNDLES" },
  { display_order: 4, page_type_cd: 'PRODUCT', module_cd: "RECORD_LABEL" },
  { display_order: 5, page_type_cd: 'PRODUCT', module_cd: "EXTRA_DATA" },
  { display_order: 6, page_type_cd: 'PRODUCT', module_cd: "SPOTIFY_EMBED" },
  { display_order: 7, page_type_cd: 'PRODUCT', module_cd: "DESCRIPTION" },
  { display_order: 8, page_type_cd: 'PRODUCT', module_cd: "RELATED_ARTISTS" },
  { display_order: 9, page_type_cd: 'PRODUCT', module_cd: "TRACKLIST" },
  { display_order: 10, page_type_cd: 'PRODUCT', module_cd: "VIDEOS" },
  { display_order: 11, page_type_cd: 'PRODUCT', module_cd: "REVIEWS" },
  { display_order: 12, page_type_cd: 'PRODUCT', module_cd: "RELATED_PRODUCTS" },

  { display_order: 1, page_type_cd: 'ARTIST', module_cd: "PHOTO" },
  { display_order: 2, page_type_cd: 'ARTIST', module_cd: "BIO" },
  { display_order: 3, page_type_cd: 'ARTIST', module_cd: "RELATED_ARTISTS" },
  { display_order: 4, page_type_cd: 'ARTIST', module_cd: "RELEASES" },
  { display_order: 5, page_type_cd: 'ARTIST', module_cd: "TOUR" },
  { display_order: 6, page_type_cd: 'ARTIST', module_cd: "VIDEOS" },
  { display_order: 7, page_type_cd: 'ARTIST', module_cd: "NEWS" },
  { display_order: 8, page_type_cd: 'ARTIST', module_cd: "CONTACTS" },
  { display_order: 9, page_type_cd: 'ARTIST', module_cd: "PRESSROOM" },

  { display_order: 1, page_type_cd: 'PRESSROOM', module_cd: "PRESSROOM_HEADER" },
  { display_order: 2, page_type_cd: 'PRESSROOM', module_cd: "CONTACTS" },
  { display_order: 3, page_type_cd: 'PRESSROOM', module_cd: "PRESS_MATERIAL" },
  { display_order: 4, page_type_cd: 'PRESSROOM', module_cd: "PRESSROOM_PHOTOS" },
  { display_order: 5, page_type_cd: 'PRESSROOM', module_cd: "ALBUM_ART" },
  { display_order: 6, page_type_cd: 'PRESSROOM', module_cd: "VIDEOS" },
  { display_order: 7, page_type_cd: 'PRESSROOM', module_cd: "NEWS" },
  { display_order: 8, page_type_cd: 'PRESSROOM', module_cd: "TOUR" },

]

//~~~~~~~~~~~~~~~~~~~~~~
//~~~ SHIPPING STUFF ~~~
//~~~~~~~~~~~~~~~~~~~~~~
export const defaultShipping = 'USPS'
export const HANDLING_AMOUNT = .75;
export const INTERNATIONAL_MAIL_SHIPPING_RATE_PER_POUND = 8.75;

// USPS
export const USPS_USER_ID = '226WELLE3163';

// FEDEX
export const FEDEX_TRANSACTION_KEY = 'Y4oOhqJRHvChTAyB';
export const FEDEX_ACCOUNT = '246599432';
export const FEDEX_METER = '2885058';
export const FEDEX_WSDL_FILE = 'RateService_v1-production.wsdl';

// HQ Address
export const SENDER_STREET1 = '717 S. Neil St.';
export const SENDER_STREET2 = '';
export const SENDER_CITY = 'Champaign';
export const SENDER_STATE = 'IL';
export const SENDER_ZIP = '61820';

export const INTERNATIONAL_RATES = ['FREE', 'FLAT', 'USPS', 'INTERNATIONAL', 'FEDEX']
export const DOMESTIC_RATES = ['FREE', 'FLAT', 'USPS', 'FEDEX']

export const SHIPPING_TYPE_CD = {
  fedex: {
    label: 'FedEx',
    url: 'http://www.fedex.com/Tracking?language=english&cntry_code=us&track.x=0&track.y=0&tracknumbers='
  },
  stamps_com: {
    label: 'US Mail',
    url: 'https://tools.usps.com/go/TrackConfirmAction.action?tRef=fullpage&tLc=1&text28777=&tLabels='
  },

  USPS: {
    label: 'US Mail',
    url: 'https://tools.usps.com/go/TrackConfirmAction.action?tRef=fullpage&tLc=1&text28777=&tLabels='
  },
  INTERNATIONAL: {
    label: 'International',
    url: ''
  },
  FEDEX: {
    label: 'FedEx',
    url: 'http://www.fedex.com/Tracking?language=english&cntry_code=us&track.x=0&track.y=0&tracknumbers='
  },
  FLAT: {
    label: 'Flat Rate',
    url: 'https://tools.usps.com/go/TrackConfirmAction.action?tRef=fullpage&tLc=1&text28777=&tLabels='
  },
  FREE: {
    label: 'FREE',
    url: 'http://www.fedex.com/Tracking?language=english&cntry_code=us&track.x=0&track.y=0&tracknumbers='
  }
}
export const currencyRound = (value) => {
  if (!value) {
    return 0;
  }
  return Number((Math.round(value * Math.pow(10, 2)) / Math.pow(10, 2)).toFixed(2))
}

export const currencyFormat = (value) => {
  if (!value) {
    value = 0;
  }
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(value)
}



export const PHOTO_SIZES = {
  ACCOUNT_LOGO: {
    medium: { width: 600 },
    thumbnail: { width: 110 },
    icon: { width: 60 }
  }, BANNERS: {
    medium: { width: 1440, },
    thumbnail: { width: 192 },
    icon: { width: 96 }
  }, STORE_PAGE_ITEM: {
    medium: { width: 600 },
    thumbnail: { width: 300 },
    icon: { width: 60 }
  }, NEWS_POST: {
    medium: { width: 1200 },
    thumbnail: { width: 300 },
    icon: { width: 60 }
  }, SPLASH: {
    medium: { width: 900 },
    thumbnail: { width: 300 },
    icon: { width: 60 }
  }, ALBUM: {
    medium: { width: 1400 },
    thumbnail: { width: 300 },
    icon: { width: 60 }
  }, ARTIST: {
    medium: { width: 900 },
    thumbnail: { width: 300 },
    icon: { width: 60 }
  }, TOOLBAR: {
    medium: { width: 200 },
    thumbnail: { width: 125 },
    icon: { width: 100 }
  }, FAVICON: {
    medium: { width: 32 },
    thumbnail: { width: 32 },
    icon: { width: 32 }
  }
}

// ~~~~~~~~~~~~~~~~~~~~~
// LOYALTY REWARD POINTS
// ~~~~~~~~~~~~~~~~~~~~~

// Single Points = 5
// Double Points = 10
export const LOYALTY_POINTS_PER_DOLLAR = 5

// exponential levels
export const LOYALTY_LEVELS = [0, 50, 175, 450, 750, 1250, 1800, 2500, 3200, 4000, 5000, 6250, 7500, 8750, 10000, 11250, 12800, 14450, 16200, 18050, 20000]

export const LOYALTY_REWARD_TYPES = {
  GIFT_CARD: 'GIFT_CARD',
  PRODUCT: 'PRODUCT'
}

export const LOYALTY_REWARDS = [{
  id: 1,
  price: 10000,
  minPoints: 0,
  type: LOYALTY_REWARD_TYPES.GIFT_CARD,
  batchId: 44,
  name: '$5 PV Credit',
  src: 'https://polyvinyl-public.s3.amazonaws.com/e987eff4a7c7b7e580d659feb6f60c1a.jpg'
}, {
  id: 2,
  price: 20000,
  minPoints: 10000,
  type: LOYALTY_REWARD_TYPES.GIFT_CARD,
  batchId: 45,
  name: '$10 PV Credit',
  src: 'https://polyvinyl-public.s3.amazonaws.com/e987eff4a7c7b7e580d659feb6f60c1a.jpg'
}, {
  id: 3,
  price: 50000,
  minPoints: 25000,
  type: LOYALTY_REWARD_TYPES.GIFT_CARD,
  batchId: 44,
  name: '$25 PV Credit',
  src: 'https://polyvinyl-public.s3.amazonaws.com/e987eff4a7c7b7e580d659feb6f60c1a.jpg'
}, {
  id: 4,
  price: 50000,
  minPoints: 15000,
  type: LOYALTY_REWARD_TYPES.PRODUCT,
  name: 'PV Members Pin',
  productInstanceId: 6548,
  src: `https://polyvinyl-public.s3.amazonaws.com/4392e631da381761421d5e1e0c3de25f_be500ca1b05cc90b58524caa88c01aa9abd2f25b_medium.jpg`
}]

export const GARAGE_SALE_HTML = `<p>
Shop each Garage Sale category here:
<a
  href="https://www.polyvinylrecords.com/store/garage_sale_lps"
  style="background-color: initial;"
  >LP</a
>,
<a
  href="https://www.polyvinylrecords.com/store/garage_sale_cds"
  style="background-color: initial;"
  >CD</a
>, <a href="/store/garage_sale_7s"> 7"</a>,
<a href="/store/garage_sale_cassette"> Cassette</a>,
<a href="/store/garage_sale_clothing"> Clothing</a>,
<a href="/store/garage_sale_merch"> Merch</a>,
<a href="/store/garage_sale_nonpolyvinyl"> Non-Polyvinyl</a>,
<a
  href="https://www.polyvinylrecords.com/store/garage_sale_surprise_me"
  style="background-color: initial;"
  >Surprise Me</a
>, and <a href="/store/garage_sale_test_pressings">Test Pressings</a>.
</p>
<hr />
<p>
Thanks for stopping by our virtual Garage Sale! Hope you find something you
want to take home with you.
</p>
<p>
Throughout the year, we accumulate our fair share of records that have somehow
or another acquired superficial damage to their packaging. The Garage Sale is
the one time of year when we offer them to music lovers like yourself. Some
are worse than others and we've done our best to come up with fair prices
based on availability and condition.
</p>
<p>
This is all to say that the jacket of the record you receive might not be in
mint condition, but the vinyl inside is still pristine and guaranteed to play.
(Hurry, though! Quantities are limited.)
</p>
<p>
We’ve also combed through our entire catalog and handpicked + lowered the
price on a variety of albums that are in need of a loving home, so feel free
to give something new a try, and if you like what you hear -- come back for
more. We’ll be here all summer!
</p>
`
export const GARAGE_SALE_CD_HTML = `<p>
Shop each Garage Sale category here:
<a
  href="https://www.polyvinylrecords.com/store/garage_sale_lps"
  style="background-color: initial;"
  >LP</a
>,
<a
  href="https://www.polyvinylrecords.com/store/garage_sale_cds"
  style="background-color: initial;"
  >CD</a
>, <a href="/store/garage_sale_7s"> 7"</a>,
<a href="/store/garage_sale_cassette"> Cassette</a>,
<a href="/store/garage_sale_clothing"> Clothing</a>,
<a href="/store/garage_sale_merch"> Merch</a>,
<a href="/store/garage_sale_nonpolyvinyl"> Non-Polyvinyl</a>,
<a
  href="https://www.polyvinylrecords.com/store/garage_sale_surprise_me"
  style="background-color: initial;"
  >Surprise Me</a
>, and <a href="/store/garage_sale_test_pressings">Test Pressings</a>.
</p>
<hr />
<p>
Thanks for stopping by our virtual Garage Sale! Hope you find something you
want to take home with you.
</p>
<p>
Throughout the year, we accumulate our fair share of CDs that have somehow or another acquired superficial damage to their packaging. The Garage Sale is the one time of year when we offer them to music lovers like yourself.
</p>
<p>
All CDs are guaranteed to be scratch-free and will play with absolutely no problem.
</p>
<p>
Any CD normally in a jewel case will be sent in a plastic sleeve. The tray card and the booklet are both included and can easily be placed in a new jewel case. Any CD normally in a digipak will be sent in the digipak, just not shrinkwrapped. There might also be a line drawn through the barcode.
</p>
<p>
We’ve also combed through our entire catalog and handpicked + lowered the price on a variety of albums that are in need of a loving home, so feel free to give something new a try, and if you like what you hear -- come back for more. We’ll be here all summer!
</p>
`
